import axios, { endpoints } from 'src/utils/axios';
import { paths } from 'src/routes/paths';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

//Modificar de acuerdo a la lógica de la acción
export const remitoOrden = createAsyncThunk(
  'ordenForm/remitoOrden',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(endpoints.actions.remitoOrden, data);
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const facturarOrden = createAsyncThunk(
  'ordenForm/facturarOrden',
  async (
    { data, navigate }: { data: any; navigate: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(endpoints.actions.facturarOrden, data);
      navigate(paths.dashboard.facturacion.facturacion, {
        state: { data: response.data, openModalFromOrden: true },
      });
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al querer facturar la orden.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const anularOrdenF = createAsyncThunk(
  'ordenForm/anularOrdenF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(endpoints.actions.anularOrdenF, data);
      handleOKRequest(response, 'La orden fue correctamente anulada.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarRecibidaOrdenF = createAsyncThunk(
  'ordenForm/marcarRecibidaOrdenF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarRecibidaOrdenF,
        data
      );
      handleOKRequest(
        response,
        'La orden fue correctamente marcada como recibida.'
      );
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarEnProduccionOrdenF = createAsyncThunk(
  'ordenForm/marcarEnProduccionOrdenF',
  async (
    { data, closePopup }: { data: any; closePopup: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarEnProduccionOrdenF,
        data
      );
      handleOKRequest(response, 'La orden pasó correctamente a producción.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    } finally {
      closePopup();
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const terminarOrdenF = createAsyncThunk(
  'ordenForm/terminarOrdenF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(endpoints.actions.terminarOrdenF, data);
      handleOKRequest(
        response,
        'La orden fue correctamente marcada como terminada.'
      );
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarControladaOrdenF = createAsyncThunk(
  'ordenForm/marcarControladaOrdenF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarControladaOrdenF,
        data
      );
      handleOKRequest(
        response,
        'La orden fue correctamente marcada como controlada.'
      );
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarDespachadaOrdenF = createAsyncThunk(
  'ordenForm/marcarDespachadaOrdenF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarDespachadaOrdenF,
        data
      );
      handleOKRequest(
        response,
        'La orden fue correctamente marcada como despachada.'
      );
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const rechazarOrdenF = createAsyncThunk(
  'ordenForm/rechazarOrdenF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(endpoints.actions.rechazarOrdenF, data);
      handleOKRequest(response, 'La orden fue correctamente rechazada.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const finalizarOrdenF = createAsyncThunk(
  'ordenForm/finalizarOrdenF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(endpoints.actions.finalizarOrdenF, data);
      handleOKRequest(
        response,
        'La orden fue correctamente marcada como finalizada.'
      );
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarPlanificadaOrdenF = createAsyncThunk(
  'ordenForm/marcarPlanificadaOrdenF',
  async (
    { data, mode, closePopup }: { data: any; mode: string; closePopup: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(
        endpoints.actions.marcarPlanificadaOrdenF,
        data
      );
      handleOKRequest(
        response,
        'La orden fue correctamente marcada como planificada.'
      );
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    } finally {
      if (mode === 'add') closePopup();
    }
  }
);
